import { apiClient } from '@/services/ApiClient.js'

export class BrandService {
  query

  constructor(query) {
    this.query = query
  }

  getBrands() {
    return apiClient
      .get('brands', {
        params: this.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrandsByCategory(categoryId) {
    return apiClient
      .get('categories/' + categoryId + '/brands')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrand(id) {
    return apiClient
      .get('brands/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrandCategories(id) {
    return apiClient
      .get('brands/' + id + '/categories')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  createBrand(brand, categories) {
    return apiClient
      .post('brands', {
        name: brand,
        categories
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateBrand(id, brand, categories) {
    return apiClient
      .patch('brands/' + id, {
        name: brand,
        categories
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  destroyBrand(id) {
    return apiClient
      .delete('brands/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  searchBrand(brand) {
    return apiClient
      .get('brands/search', { params: { brand } })
      .then(response => response)
      .catch(err => {
        throw err
      })
  }

  getBrandsByProduct(productId) {
    return apiClient
      .get('/brands/by-product/' + productId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
